<template>
  <div class="content">
    <van-nav-bar title="发票信息" left-arrow @click-left="onClickLeft" />
    <van-form >
      <!-- <van-field
        v-model="form.kpzdbs"
        name="kpzdbs"
        readonly
        label="开票终端标识"
      /> -->
      <!-- <van-field v-model="form.jqbh" name="jqbh" readonly label="机器编号" /> -->
      <van-field
        v-model="form.addDate"
        name="addDate"
        label="开票日期"
      />
      <van-field
        v-model="fplxmc"
        name="fplxmc"
        readonly
        label="发票类型"
      />
      <van-field
        v-model="form.fpdm"
        name="fpdm"
        readonly
        label="发票代码"
      />
       <van-field
        v-model="form.fphm"
        name="fphm"
        readonly
        label="发票号码"
      />

       <van-field
        v-model="form.xhdwmc"
        name="ghdwmc"
        readonly
        label="销售方名称"
      />
      
      <van-field
        v-model="form.ghdwmc"
        name="ghdwmc"
        readonly
        label="购货单位"
      />

      <van-field
        v-model="form.ghdwsbh"
        name="ghdwsbh"
        readonly
        label="购货单位识别号"
      />

      <van-field v-model="form.hjje" name="hjje" readonly label="合计金额" />

      <van-field v-model="form.hjse" name="hjse" readonly label="合计税额" />

      <van-field v-model="form.jshj" name="jshj" readonly label="价税合计" />

       <!-- <van-field v-model="this.fpzt" name="fpzt" readonly label="发票状态" /> -->

      <div style="margin: 16px;text-align: center;">


       <!-- <van-button icon="search" size="small" type="primary" @click="openInvoice()" >查看发票</van-button>
       -->

      <van-button icon="search" v-if="!isButtonDisabled"  type="primary" style="margin-left: 10px" @click="downInvoice()" >发票下载</van-button>

     <van-button icon="paid"   style="margin-left: 10px" type="primary"
       @click="invoicePushDialog=true"  >重新推送</van-button>
      <!-- <van-button round block type="info" native-type="submit">打印</van-button>
      <van-button round block type="info" native-type="submit">负数</van-button>
      <van-button round block type="info" native-type="submit">作废</van-button> -->

        <!-- <van-button type="info" style="margin: 1rem">打印</van-button> -->
        <!-- <van-button
          type="info"
          v-if="form.jstatus == 1"
          style="margin: 1rem"
          @click="redInfo"
          >负数</van-button
        >
        <van-button
          type="info"
          v-if="form.jstatus == 1"
          style="margin: 1rem"
          @click="invalidInvoice"
          >作废</van-button
        > -->
      </div>

   

    </van-form>

    <van-dialog  v-model="invoicePushDialog" title="重新推送" confirmButtonColor="#1989fa" 
      show-cancel-button  @confirm="invoicePushOpetator()">
        <!-- <van-field   v-model="phone" label="推送手机" clearable maxlength="11"     placeholder="推送手机" /> -->
        <van-field   v-model="mail" label="推送邮箱"  clearable  maxlength="50"  placeholder="推送邮箱" />
     </van-dialog>

      
 <van-dialog  v-model="iframeShow" title="查看发票" >
   <iframe :src="linkUrl" id="bdIframe" frameborder="0" ></iframe>
 </van-dialog>

  <van-dialog  v-model="invoiceShow" title="发票二维码" >

     <div id="qrcode" ref="qrcode" v-if="invoiceShow" style="margin:54px;"></div>
  
 </van-dialog>

  </div>
</template>


<script>
import QRCode from "qrcodejs2";
import Vue from "vue";
import { Form } from "vant";
import { Field } from "vant";
import { Dialog } from 'vant';
Vue.use(Form);
Vue.use(Field);
Vue.use(Dialog);
import { Toast, Indicator } from "mint-ui";
export default {
  data() {
    return {
      form: {
        kpzdbs: "1",
        fplxdm: "",
        jqbh: "",
        jstatus: "",
        addDate: "",
        ghdwmc: "",
        ghdwsbh: "",
        hjje: "",
        hjse: "",
        jshj: "",
        id: "",
        pdfurl:"",
        fplxdm: "",
      },
      isButtonDisabled:false,
      invoiceShow:false,
      linkUrl:'',
      phone:'',
      mail:'',
      iframeShow:false,
      invoicePushDialog:false,
      uid: "",
      fplxmc:"",
      fpzt:""
    };
  },
  mounted() {
    this.init();
  },
  created() {
  },
  methods: {
    downInvoice(){   //查看pdf生成二维码
      //   this.invoiceShow=true;
      //   //this.isButtonDisabled=false;  //点击按钮先禁用
      //   this.$nextTick(function(){
      //   let dom = document.getElementById("qrcode");
      //   while (dom.firstChild) {
      //     dom.removeChild(dom.firstChild);
      //   }
      //   document.getElementById('qrcode').innerHTML = '';
      //   this.creatQrCode();
      // });
      this.isButtonDisabled=true;  //点击按钮先禁用
      if(this.form.pdfurl!=''){
                     console.log('有值');
                     this.invoiceShow=true;
                      this.$nextTick(function(){
                      let dom = document.getElementById("qrcode");
                      while (dom.firstChild) {
                        dom.removeChild(dom.firstChild);
                      }
                      let qrcode = new QRCode('qrcode', {
                                  width: 200,
                                  height: 200,
                                  text: this.form.pdfurl // 二维码地址
                              });
                        this.isButtonDisabled = false;
                      });  
      }else{
               this.creatQrCode();
      }
    
    },
  
    creatQrCode(){
          const url = "/memberBusiness/invoice/" + this.form.id + "/listPdf";
          this.$axios
            .get(url)
            .then((data) => {
                  console.log(data);
                 if(data.code==200){
                      this.invoiceShow=true;
                      this.$nextTick(function(){
                      let dom = document.getElementById("qrcode");
                      while (dom.firstChild) {
                        dom.removeChild(dom.firstChild);
                      }
                      let qrcode = new QRCode('qrcode', {
                                  width: 200,
                                  height: 200,
                                  text: data.data // 二维码地址
                              });
                        this.isButtonDisabled = false;
                    });    
                 }else{
                    Toast({
                      message: data.message,
                      position: "middle",
                      duration: 2000,
                    });
                    this.isButtonDisabled = false;
                 }
            })
            .catch((error) => {
             console.log(error);  
             this.isButtonDisabled = false;
              //请求失败返回的数
              Toast({
                message: error.message,
                position: "middle",
                duration: 2000,
              });
            });
      
    },
     invoicePushOpetator(){
      var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      var reg_email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
       if(this.mail!==''){
        if(!reg_email.test(this.mail)){
           Toast('邮箱格式异常')
            return ''
        }
      }
        if(this.phone!==''){
        if(!reg_tel.test(this.phone)){
             Toast('手机号格式异常');
              return ''
        }
      }
      if(this.phone===''&&this.mail===''){
        Toast('手机号和邮箱至少填写一个')
        return ''
      }
      
       this.$axios
        .post("/memberBusiness/invoice/invoicePush",{
          phone:this.phone,
          email:this.mail,
          id:this.form.id
       
        }).then((data) => {
            Toast(data.message);
            this.invoicePushDialog=false;
      });



    },

    openInvoice(){

    

    const url = "/memberBusiness/invoice/" + this.form.id + "/listPdf";
    this.$axios
      .get(url)
      .then((data) => {
      
        this.iframeShow=true;
        this.linkUrl=data.data;

      })
      .catch((error) => {
        //请求失败返回的数
        Toast({
          message: error.message,
          position: "middle",
          duration: 2000,
        });
      });
    },
    init() {
       this.form = this.$route.query.datass;
       console.log(this.form);
       switch(this.form.fplxdm){
         case "004":
           this.fplxmc="增值税专票";
          break;
         case "007":
           this.fplxmc="增值税纸票";
          break;
          case "026":
           this.fplxmc="增值税普票";
          break;
          case "82":
           this.fplxmc="数电普票";
          break;
          case "81":
           this.fplxmc="数电专票";
          break;
 
       }
        switch(this.form.jstatus){

         case 1:
           this.fpzt="开票成功";
          break;
         case 2:
           this.fpzt="作废发票";
          break;
          case 3:
           this.fpzt="红冲发票";
          break;
          case 4:
           this.fpzt="开票失败";
          break;

        }

  
    },
    redInfo() {
      // //跳转到开票，设置属性
      //  this.getmodel("deviceSetting?addFlag=2");
      //  let  redInfo=new Object();
      //  redInfo.yfpdm=this.form.fpdm;
      //  redInfo.yfphm=this.form.fphm;
      //   redInfo.kplx="1";
      //   sessionStorage.setItem("redInfo",JSON.stringify(redInfo));
    },
    viewPdf() {

      
      this.$router.push("viewPdf?id="+this.form.id);
    
    },
    onClickLeft() {
      this.$router.push("order");
    },
    onSubmit(values) {},
  },
};
</script>
